import { defineAction } from '~/prix'
import { z } from 'zod'
import incentiveDocumentDeleteAction from './incentiveDocumentDelete.action.json' with { type: 'json' }
import { incentiveDocumentObject } from '../incentiveDocumentObject'

const incentiveDocumentDeleteDefinition = defineAction({
  ...incentiveDocumentDeleteAction,

  input: z.object({ id: incentiveDocumentObject.shape.id }),
  output: z.object({}),
})

export default incentiveDocumentDeleteDefinition
